// extracted by mini-css-extract-plugin
module.exports = {"heroCard":"card_heroCard__5VWET","imageContainer":"card_imageContainer__Xxnr9","image":"card_image__Th02r","title":"card_title__3CFXV","content":"card_content__twksh"};